import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#loan-payment-app', App);
